export const CanceledTransfer = () => {
  return (
    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10048_203204)">
        <circle cx="18" cy="18.5" r="17" fill="#ECAEB0" />
      </g>
      <rect x="0.5" y="1" width="35" height="35" rx="17.5" stroke="#F4F1F2" />
      <path d="M15.707 21.1497L20.651 16.2057" stroke="#090B1F" strokeWidth="2" />
      <path d="M20.6484 21.1497L15.7045 16.2057" stroke="#090B1F" strokeWidth="2" />
      <circle cx="17.9995" cy="18.5" r="5.88235" stroke="#090B1F" strokeWidth="2" />
      <defs>
        <clipPath id="clip0_10048_203204">
          <rect x="1" y="1.5" width="34" height="34" rx="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
